import { ActivityIndicator } from 'react-native';
import { Text, VStack } from '../../../components/primitives';
import { Button } from '../../../components/primitives/Button';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';

interface GeneratingStepProps {
  isError: boolean;
  onRetry: () => void;
}

export function GeneratingStep({ isError, onRetry }: Readonly<GeneratingStepProps>) {
  const { t } = useTranslation();

  if (isError) {
    return (
      <VStack spacing="md" align="center" testID="onboarding-generating-error">
        <Text variant="h5" color={colors.text.primary}>
          {t('onboardingWizard.generating.errorTitle')}
        </Text>
        <Button testID="onboarding-generating-retry" variant="secondary" onPress={onRetry}>
          {t('onboardingWizard.generating.retry')}
        </Button>
      </VStack>
    );
  }

  return (
    <VStack spacing="md" align="center" testID="onboarding-generating-loading">
      <ActivityIndicator size="large" color={colors.primary.neon} />
      <Text variant="h5" color={colors.text.primary}>
        {t('onboardingWizard.generating.title')}
      </Text>
      <Text variant="body" color={colors.text.secondary}>
        {t('onboardingWizard.generating.subtitle')}
      </Text>
    </VStack>
  );
}
